<script setup>
defineProps({
  name: { type: String, required: true },
  imageUrl: { type: String, default: null },
  count: { type: Number, default: null },
  highlighted: { type: Boolean, default: false },
})
defineEmits(['select'])
</script>

<template>
  <button type="button" class="category-circle-card" :class="{ 'is-new': highlighted }" @click="$emit('select')">
    <span class="circle-image-wrapper" aria-hidden="true">
      <img v-if="imageUrl" :src="imageUrl" alt="" class="circle-image" />
      <span v-else class="circle-placeholder"><i class="pi pi-folder"></i></span>
    </span>
    <span class="circle-name">{{ name }}</span>
    <span v-if="count !== null" class="circle-count">{{ count }} товаров</span>
  </button>
</template>

<style scoped>
.category-circle-card {
  flex-shrink: 0;
  width: 112px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.category-circle-card:hover { transform: translateY(-4px); }
.category-circle-card:focus-visible { outline: 2px solid #333; outline-offset: 5px; border-radius: 8px; }
.category-circle-card.is-new .circle-image-wrapper { background: #f0ebe5; }
.circle-image-wrapper {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  overflow: hidden;
  background: #f8f8f8;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: box-shadow 0.2s ease;
}
.category-circle-card:hover .circle-image-wrapper { box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08); }
.circle-image { width: 100%; height: 100%; object-fit: cover; }
.circle-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  color: #ccc;
  font-size: 32px;
}
.circle-name { font-size: 14px; font-weight: 500; color: #333; line-height: 1.3; overflow-wrap: anywhere; max-width: 100%; }
.circle-count { margin-top: 5px; font-size: 12px; color: #777; }
@media (max-width: 768px) {
  .circle-image-wrapper { width: 75px; height: 75px; }
  .circle-name { font-size: 12px; }
}
@media (max-width: 600px) {
  .circle-image-wrapper { width: 65px; height: 65px; }
}
</style>
